var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.datos,"loading":_vm.isLoading,"label":_vm.label,"item-text":"text","return-object":"","hide-details":"","outlined":"","dense":"","clearable":""},on:{"change":_vm.emitir},model:{value:(_vm.seleccionado),callback:function ($$v) {_vm.seleccionado=$$v},expression:"seleccionado"}})
}
var staticRenderFns = []

export { render, staticRenderFns }